import { render, staticRenderFns } from "./positionCard.vue?vue&type=template&id=fa974c56&"
import script from "./positionCard.vue?vue&type=script&lang=js&"
export * from "./positionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports